import { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
// import { useNavigate } from 'react-router-dom'
import WTypography from '../../../../Components/whiteTypography'
import { makeGetRequest } from 'utils/api'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

function DonutChart1({ reports, setHeaderValue, fetchMesActifs, oldData }) {
  const getAppStore = useSelector((store) => store.appStore).appStore
  // const navigate = useNavigate()
  const params = useParams()
  const { slug } = params
  const [click, setClick] = useState(false)
  const [revData, setRevData] = useState({
    labels: ['Revenus salariaux', 'Revenus passifs', 'revenus autres'],
    datasets: [
      {
        data: [80, 5, 15],
        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
        hoverOffset: 4,
        precision: 0,
      },
    ],
  })
  const optiondonut = {
    responsive: true,
    aspectRatio: 1.3,
    clip: true,
    onClick: async function (evt, element) {
      if (reports?.nom !== 'actifs' && reports?.nom !== 'passifs') {
        let percentageAmount = []
        if (click) {
          // setHeaderValue(0)
          setClick(false)
          // try {
          //   fetchMesActifs('year')
          // } catch (error) {
          //   console.error(error)
          // }
        } else {
          if (element.length > 0) {
            let catName = revData.labels[element[0].index]

            const response = await makeGetRequest(
              `/api/Finance/singlereports/${catName.replace(' ', '-')}/?nom=${reports.nom}`,
              {},
              true,
            )
            if (response.status === 200) {
              setClick(true)
              setHeaderValue(response.data.header_value)
              response.data.sous_cat.map((v, i) => {
                percentageAmount.push(100 / response.data.sous_cat.length.toFixed(0))
                return ''
              })
              response.data.sous_cat &&
                setRevData({
                  labels: response.data.sous_cat,
                  datasets: [
                    {
                      // label: "Répartition revenus",
                      data: percentageAmount,
                      backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
                      borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
                      borderWidth: 1,
                      hoverOffset: 4,
                      precision: 0,
                    },
                  ],
                })
            }
            // you can also get dataset of your selected element
            // data.datasets[element[0]._datasetIndex].data[element[0]._index];
          }
        }
      }
    },
    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          // Calculate percentage for display
          let total = 0
          let dataArr = ctx.chart.data.datasets[0].data
          dataArr.map(data => {
            total += parseFloat(data)
          })
          let percentage = ((parseFloat(value) * 100) / total).toFixed(1)
          return [
            ctx.chart.data.labels[ctx.dataIndex],
            percentage + '%'
          ]
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',
        clamp: true,
        display: 'auto',
      },

      legend: {
        display: slug === 'R' || slug === 'D' ? getAppStore.legend : false,
        position: 'right',
        labels: {
          color: 'white',
        },
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }
  useEffect(() => {
    let groupName = []
    let amount = []

    // storing the groups with actual amounts (not percentages)
    reports &&
      reports.calculation &&
      reports.calculation.group_of_categories.map((cat, i) => {
        groupName.push(cat.name)
        amount.push(parseFloat(cat.aggregate).toFixed(2))
        return ''
      })

    if (reports?.nom === 'actifs') {
      setRevData({
        labels: oldData?.calculation?.chart_type?.actifs?.labels,
        datasets: [
          {
            data: oldData?.calculation?.chart_type?.actifs?.data,

            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
            hoverOffset: 4,
            precision: 0,
          },
        ],
      })
    } else if (reports?.nom === 'passifs') {
      setRevData({
        labels: oldData?.calculation?.chart_type?.passifs?.labels,
        datasets: [
          {
            data: oldData?.calculation?.chart_type?.passifs?.data,

            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
            hoverOffset: 4,
            precision: 0,
          },
        ],
      })
    } else {
      setRevData({
        labels: groupName,
        datasets: [
          {
            // label: "Répartition revenus",
            data: amount, // Use actual amounts instead of percentages
            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
            hoverOffset: 4,
            precision: 0,
          },
        ],
      })
    }
  }, [reports])

  const RevDoughnutChart = () => (
    <>
      {reports && reports.calculation && reports.calculation.group_of_categories.length === 0 ? (
        <WTypography variant="h6" align="center" marginTop="10rem">
          Aucune donnée
        </WTypography>
      ) : (
        <Doughnut data={revData} options={optiondonut} />
      )}
    </>
  )

  return (
    <>
      <RevDoughnutChart />
    </>
  )
}

export default DonutChart1
